import { OrganizationSecretItems } from 'libs/end-to-end/src/types/secrets/organization-secret-items';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import React from 'react';
import { useOrganizationSecretSelectionModal } from 'apps/sigma2-ui/src/secrets/lib/useOrganizationSecretSelectionModal';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { AdminTable } from 'apps/sigma2-ui/src/components/AdminLayout';
import { OrganizationSecretEditComponent } from 'apps/sigma2-ui/src/secrets/components/OrganizationSecretEditComponent';
import { OrganizationSecretCreateComponent } from 'apps/sigma2-ui/src/secrets/components/OrganizationSecretCreateComponent';
import { Modal } from 'apps/sigma2-ui/src/components/ui/Modal';
import { ReadPatternHook } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

export const OrganizationSecretSelectionModal = ({
  secretReference,
  setSecretReference,
  onClose,
  organizationId,
  listSecretsPattern,
}: {
  secretReference: SecretReference | null;
  setSecretReference: (secretReference: SecretReference | null) => void;
  onClose: () => void;
  organizationId: string;
  listSecretsPattern: ReadPatternHook<OrganizationSecretItems>;
}) => {
  const {
    modalTitle,
    secretRows,
    secretHeadings,
    displayMode,
    goToSelectSecretButtonBehavior,
    goToSelectSecretButtonLabel,
    goToCreateSecretButtonLabel,
    goToCreateSecretButtonBehavior,
    editSecretId,
    createOnComplete,
    editOnComplete,
    reloadButtonBehavior,
    reloadButtonLabel,
  } = useOrganizationSecretSelectionModal({
    secretReference,
    setSecretReference,
    onClose,
    organizationId,
    listSecretsPattern,
  });

  return (
    <Modal show={true} onClose={onClose} title={modalTitle} scrollable={true}>
      <div className={'h-[80vh]'}>
        {displayMode === 'select' && (
          <Spacing size={'md'} direction={'vertical'}>
            <Spacing size={'md'} direction={'horizontal'}>
              <Button
                behavior={goToCreateSecretButtonBehavior}
                text={goToCreateSecretButtonLabel}
              />

              <Button
                behavior={reloadButtonBehavior}
                text={reloadButtonLabel}
              />
            </Spacing>

            <AdminTable headings={secretHeadings} rows={secretRows} />
          </Spacing>
        )}

        {displayMode === 'create' && (
          <Spacing size={'md'} direction={'vertical'}>
            <Button
              behavior={goToSelectSecretButtonBehavior}
              text={goToSelectSecretButtonLabel}
            />

            <OrganizationSecretCreateComponent
              organizationId={organizationId}
              onComplete={createOnComplete}
            />
          </Spacing>
        )}

        {displayMode === 'edit' && editSecretId && (
          <Spacing size={'md'} direction={'vertical'}>
            <Button
              behavior={goToSelectSecretButtonBehavior}
              text={goToSelectSecretButtonLabel}
            />

            <OrganizationSecretEditComponent
              organizationId={organizationId}
              editSecretId={editSecretId}
              onComplete={editOnComplete}
            />
          </Spacing>
        )}
      </div>
    </Modal>
  );
};
